import { Grid } from '@mui/material';
import { useAppSelector } from 'app/hooks';
import InboxLists from 'components/molecules/List/InboxLists';
import { selectChat } from 'features/auth/chatSlice';
import { UserData } from 'interfaces/UserData.interface';
import React from 'react';

interface ISingleMessageRow {
  index: number;
  indexHandler: (username: string) => void;
  user: UserData;
}

function SingleMessageRow({ index, indexHandler, user }: ISingleMessageRow) {
  const chatState = useAppSelector(selectChat);
  if (user.id) {
    return (
      <Grid
        item
        key={index}
        xs={12}
        style={{ margin: '1rem 0rem' }}
        onClick={() => indexHandler(user.username)}
      >
        <InboxLists
          selected={
            chatState.inboxUsers[chatState.currentIndex].user.id === user.id
          }
          verified={user.verified || false}
          data={user}
        />
      </Grid>
    );
  } else {
    return <></>;
  }
}

export default SingleMessageRow;
